import viewsCountImage from '../img/views_count_image.png'

import '../css/news_list_item.css'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react';
import restApiHost from '..';

function NewsListItem({news, phoneNumber}){
    const navigate = useNavigate();

    return <div className="news-item" onClick={() => navigate(`/news?news_id=${news.id}?phone=${phoneNumber}`)}>
        <div className="news-title">{news.title}</div>
        <div className="news-image-container">
            <img className="news-image" src={news.image} alt='error'/>
        </div>
        <div className="news-additional-info-container">
            <div className="news-date">{news.date}</div>
            <div className="news-views-count-container">
                <div className="news-views-count">{news.views_count}</div>
                <div className="news-views-count-image-container">
                    <img className="news-views-count-image" src={viewsCountImage} alt='error'/>
                </div>
            </div>
        </div>
            <div className='news-short-text'>{news.text}</div>
        </div>
};
export default NewsListItem;